import PropTypes from 'prop-types'
import styled from 'styled-components'

import { color } from 'styles/colors'
import React from 'react'
import { NavLink } from 'react-router-dom'

const propTypes = {
  id: PropTypes.string,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  linkUrl: PropTypes.string,
  linkDisplay: PropTypes.string
}

const defaultProps = {
  id: '',
  errorMessage: '',
  className: '',
  linkUrl: '',
  linkDisplay: ''
}

const ErrorMessage = ({ id, errorMessage, className, linkUrl, linkDisplay }) => {
  return (
    <>
      {
        !_.isEmpty(errorMessage) &&
        <S.ErrorMessage htmlFor={id} {...{ className }}>
          {errorMessage}
          {
            linkUrl && linkDisplay &&
              <NavLink to={linkUrl}>
                {linkDisplay}
              </NavLink>
          }
        </S.ErrorMessage>
      }
    </>
  )
}

ErrorMessage.propTypes = propTypes
ErrorMessage.defaultProps = defaultProps

export default ErrorMessage

const S = {
  ErrorMessage: styled.label`
    float: right;
    color: ${color('errorMessage')};
    font-size: 13px;
    font-weight: bold;
  `
}
